import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { AddLeadDialogComponent } from '../add-lead-dialog/add-lead-dialog.component';

import { CommonService, AlertService, AdminService, ProfileService, FirebaseService } from '../../_services/';
import { environment } from '../../../environments/environment';
import { Subject } from "rxjs";
import  { signInEmailList } from '../../_helper/global';

// For the search only version
import algoliasearch from 'algoliasearch';
import { takeUntil } from 'rxjs/operators';


const client = algoliasearch(environment.algolia.appId, environment.algolia.adminAPIKey);
const index = client.initIndex('contacts');
const index2 = client.initIndex('projects');


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  firstName;
  lastName;
  menuList:any=[];
  menuListId:any[]=[];
  jobFunctionList:any=[];
  profileImagePath:String;
  userProfile:Object;
  leadSearchAreaStatus:Boolean;
  signInVisible:Boolean;
  projectSearchAreaStatus:Boolean;
  searchAreaStatus:Boolean;
  contactType:String="";
  searchForm:FormGroup;
  searchProjects:any[] = [];
  searchContacts:any[] = [];
  searchContactIds:String[] = [];
  detroyed$ = new Subject();
  subscription:any;
  subscription2:any;
  constructor(
    private router:Router,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService,
    public dialog: MatDialog,
    private _profile : ProfileService,
    private route: ActivatedRoute,
    private _firebase : FirebaseService,
    private fb: FormBuilder
    ) { }

  ngOnInit() {
    this.signInVisible = signInEmailList.includes(localStorage.getItem('rs-email')) ? true : false;
    const obj = {
      firstName : localStorage.getItem('firstName'),
      lastName : localStorage.getItem('lastName'),
      profileImagePath : localStorage.getItem('profileImagePath')
    }
    this._profile.updateProfileStatus(obj);

    this._profile.profileStatus.pipe(takeUntil(this.detroyed$)).subscribe(profile=>{
      this.firstName = profile['firstName']; 
      this.lastName = profile['lastName']; 
      this.profileImagePath = profile['profileImagePath']; 
    })
    this._profile.leadSearchArea.pipe(takeUntil(this.detroyed$)).subscribe(status=>{
      this.searchAreaStatus = status['show'];
    })

    this.searchForm = this.fb.group({
      keyword:['',[]]
    })

  

    // this.firstName = localStorage.getItem('firstName');
    // this.lastName = localStorage.getItem('lastName');
    // this.profileImagePath = localStorage.getItem('profileImagePath') ? localStorage.getItem('profileImagePath') :'';
    // get contact manu dynamic list
    this.getContactMenuList()
    this.getJobFunctionList();

  }

  ngOnDestroy (){
    this.detroyed$.next();
    this.detroyed$.complete();
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
  }


  changeContactType(item){
    this._profile.changeContactType(item);    
  }

  logout() {
    
    this._firebase.SignOut();
    localStorage.removeItem('uid');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('profileImagePath');
    localStorage.removeItem('contactId');
    localStorage.removeItem('rs-email');
    this.router.navigate(["/"]);
    // localStorage.removeItem('user');
    // this.router.navigateByUrl("/login", { skipLocationChange: true })
    //   .then(() => this.router.navigate(["login"]));
  }

  getContactMenuList(){
    // this._common.showLoader(true);
    this.subscription = this._admin.getContactMenuList().subscribe(result=>{
      // this._common.showLoader(false);
      this.menuList = result.map(item=>item.payload.doc.data().contacts_menu_title);
      
      this.menuListId = result.map(item=>item.payload.doc.id);
     if(this.menuListId.indexOf('lead')>-1){
       const leadIndex = this.menuListId.indexOf('lead');
       // sort menu title
       let temp = this.menuList[0];
       this.menuList[0] = this.menuList[leadIndex];
       this.menuList[leadIndex] = temp;
       // sort menu Id
       let temp1 = this.menuListId[0];
       this.menuListId[0] = this.menuListId[leadIndex];
       this.menuListId[leadIndex] = temp1;

     }
     if(this.menuListId.indexOf('client')>-1){
       const clientIndex = this.menuListId.indexOf('client');
       // sort menu title
      let temp = this.menuList[1];
      this.menuList[1] = this.menuList[clientIndex];
      this.menuList[clientIndex] = temp;
      // sort menu id
      let temp1 = this.menuListId[1];
      this.menuListId[1] = this.menuListId[clientIndex];
      this.menuListId[clientIndex] = temp1;

    }
    if(this.menuListId.indexOf('signin')>-1){
      const signinIndex = this.menuListId.indexOf('signin');
      // sort menu title
      let temp = this.menuList[2];
      this.menuList[2] = this.menuList[signinIndex];
      this.menuList[signinIndex] = temp;
      //sort menu id
      let temp1 = this.menuListId[2];
      this.menuListId[2] = this.menuListId[signinIndex];
      this.menuListId[signinIndex] = temp1;

    }
    if(this.menuListId.indexOf('architect')>-1){
      const architectIndex = this.menuListId.indexOf('architect');
      // sort menu title
      let temp = this.menuList[3];
      this.menuList[3] = this.menuList[architectIndex];
      this.menuList[architectIndex] = temp;
      // sort menu name
      let temp1 = this.menuListId[3];
      this.menuListId[3] = this.menuListId[architectIndex];
      this.menuListId[architectIndex] = temp1;

    }

    },err=>{
      // this._common.showLoader(false);
      this._alert.error(err.error && err.error.message?err.error.message:'Something went wrong!');
    })
  }

  // get job function list...
  getJobFunctionList(){
    // this._common.showLoader(true);
    this.subscription2 = this._admin.getJobFunctionList().subscribe(result=>{
      // this._common.showLoader(false);
      for(let item of result){
        this.jobFunctionList.push({name:item.payload.doc.data()['name'],id:item.payload.doc.id,selected:false})
      }
    },err=>{
      // this._common.showLoader(false);
      this._alert.error(err.error && err.error.message ? err.error.message:'Something went wrong!');
    })
    
  }

  openAddLeadDialog(){
    this.dialog.open(AddLeadDialogComponent, {
      width: 'auto',
      data: {
        jobFunctionList: this.jobFunctionList
      }
    });
  }

toggleSearchBox(){
  this.searchAreaStatus = !this.searchAreaStatus;
}


// emptySearch(){
//   this.searchForm.patchValue({ 
//     keyword : ``
//   })
//   this.searchContacts = [];
//   this.searchProjects = [];
// }

    // Search Algolia...
    searchAlgolia(form){
      this.searchContactIds = [];
      this.searchContacts = [];
      this.searchProjects = [];
      const requestOptions = {
        headers: { }
      }
      // Search Contacts...      
      index.search(form.value.keyword, requestOptions)
      .then(({ hits }) => {
        if(form.value.keyword!=""){
          this.searchContacts = hits.map(item=>{ return {owner_first_name: item['owner_first_name'], owner_last_name: item['owner_last_name'], address: item['address'], first_name: item['first_name'], last_name: item['last_name'], mobile_phone:item['mobile_phone'], email:item['email'], objectID: item['objectID']}});
        }

        // Search Projects...
        index2.search(form.value.keyword, requestOptions)
        .then(({ hits }) => {
          if(form.value.keyword!=""){
            this.searchProjects = hits.map(item=>{ return {  owner_last_name: item['owner_last_name'], owner_first_name: item['owner_first_name'], address: item['address'], status_name: item['status_name'], name: item['name'], contact_first_name : item['contact_first_name'], contact_last_name : item['contact_last_name'], accounting_ref: item['accounting_ref'], objectID: item['objectID'] } });
          }
        })


          

        // if(form.value.keyword==""){
        //   this.searchContacts = [];
        //   this.searchProjects = [];
        // }
        /*if(form.value.keyword!="" && this.searchContactIds.length==0){
          this.contactList = [];
          this.errMsg = 'No Data Available';
          return;
        }
        if(form.value.keyword===""){
          this.getContactList([]);
        }
        else{
          this.getContactList(this.searchContactIds);
        }*/
      }); 
    }

    redirectToProject(projectId){
      this.searchForm.patchValue({ 
        keyword : ``
      })
      this.searchContacts = [];
      this.searchProjects = [];
    
      this.router.navigate(["/project", projectId]);
    }

    redirectToContact(contactId){
      this.searchForm.patchValue({ 
        keyword : ``
      })
      this.searchContacts = [];
      this.searchProjects = [];
    
      this.router.navigate(["/contact", contactId]);
    }



}
